import type React from "react";
import { TextfieldLabel as Label, Textfield } from "@similarweb/ui-components";
import Alert from "app/pages/sneakpeek/components/Alert";
import { Button } from "@similarweb/ui-components";
import {
    AlertBoxContainer,
    DangerZoneContent,
    StyledListSettingsTextFieldContainer,
} from "app/pages/workspace/common/styles";
import { i18nFilter } from "app/filters/i18nFilter";
import type { IOpportunityListItemAlertsConfig } from "app/pages/workspace/common/types";

type ListSettingsProps = {
    namePlaceHolder: string;
    listName?: string;
    error: boolean;
    mode: string;
    onDelete(e: Event): void;
    onListNameChanged(name: string): void;
    onFeedMetricsChanged(metrics: string[]): void;
    feedSettings: IOpportunityListItemAlertsConfig;
};

const ListSettings: React.FC<ListSettingsProps> = ({
    namePlaceHolder,
    listName,
    error,
    mode,
    onDelete,
    onListNameChanged,
    onFeedMetricsChanged,
    feedSettings,
}) => {
    return (
        <>
            <StyledListSettingsTextFieldContainer>
                <Textfield
                    label={i18nFilter()("workspaces.sales.opportunity-lists.edit.title")}
                    defaultValue={listName}
                    onChange={onListNameChanged}
                    error={error}
                    errorMessage={i18nFilter()("workspaces.investors.opportunity-lists.edit.title.error")}
                    placeholder={namePlaceHolder}
                    maxLength={100}
                    dataAutomation="list-settings-modal-title-text-field"
                />
            </StyledListSettingsTextFieldContainer>

            {mode === "edit" ? (
                <AlertBoxContainer>
                    <Label>Danger zone</Label>
                    <Alert
                        text={
                            <DangerZoneContent>
                                <span>{i18nFilter()("workspaces.investors.opportunity-lists.delete.text")}</span>
                                <Button
                                    onClick={onDelete}
                                    type="flatWarning"
                                    dataAutomation="list-settings-modal-delete-button"
                                    buttonHtmlType="button"
                                >
                                    {i18nFilter()("workspaces.investors.opportunity-lists.delete.button")}
                                </Button>
                            </DangerZoneContent>
                        }
                    />
                </AlertBoxContainer>
            ) : null}
        </>
    );
};

export default ListSettings;
